export default __webpack_public_path__ + "static/media/G.5dafc507.png";